import { PayloadAction } from '@reduxjs/toolkit';
import { isFormDirty } from '@ui/features/quote-builder/state/selectors/quote-builder-dirty';
import { stringifyQuote } from '@ui/features/quote-builder/state/utilities/stringify-quote';
import { WritableDraft } from 'immer';
import { uniq } from 'lodash-es';

import { QuoteBuilderStateType } from '../../types/state';
import { QuotePriceType } from '../../types/state/quote-price';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { buildIssueId } from '../utilities/issue-id';

export function buildQuotePriceRejectedIssueId({
  quoteLineUuid,
  quotePriceUuid,
}: {
  quoteLineUuid: string;
  quotePriceUuid: string;
}) {
  return buildIssueId({
    area: 'quotePrice',
    quoteLineUuid,
    quotePriceUuid,
    type: 'rejected',
  });
}

export function quotePriceCreated(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{ quoteLineUuid: string; quotePrice: QuotePriceType }>,
) {
  const { quoteLineUuid, quotePrice } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);
  const wasFormDirty = isFormDirty(state);

  quoteLine.automatable = false;
  quoteLine.quotePrices[quotePrice.uuid] = quotePrice;
  quoteLine.quotePriceUuids = uniq([
    ...quoteLine.quotePriceUuids,
    quotePrice.uuid,
  ]);

  /**
   * @AUTOSAVE @NOTE(shawk): This is a complication at the intersection of
   * auto-save and optimistic updates. We may be able to leverage middleware
   * or effects to better handle this for thunks in the future.
   */
  if (!wasFormDirty) {
    state.pendingServerData = stringifyQuote(state);
  }
}
